import type { StateCreator } from 'zustand';
import { CondoStore } from './shared';

export const createCoreSlice: StateCreator<CondoStore, [], [], Partial<CondoStore>> = (set, get) => ({
  condos: [],
  units: [],
  owners: [],
  fees: [],
  expenses: [],
  revenues: [],
  statements: [],
  payments: [],
  documents: [],
  projects: [],
  violations: [],
  maintenanceRequests: [],
  amenities: [],
  amenityBookings: [],
  boardMembers: [],
  boardMeetings: [],
  boardResolutions: [],
  workOrders: [],
  inspections: [],
  visitorAuthorizations: [],
  parkingSpots: [],
  statusCertificates: [],
  statusCertificateRequests: [],
  packages: [],
  emailSchedules: [],
  vendors: [],
  announcements: [],
  lateFeePolicy: null,
  unitTransfers: [],
  accessKeys: [],
  notifications: [],
  maintenanceSchedules: [],
  isLoading: false,
  error: null,
  loadingByKey: {},
  errorByKey: {},

  // Basic state actions
  setLoading: (loading: boolean) => set({ isLoading: loading }),
  setError: (error: string | null) => set({ error }),
  clearError: () => set({ error: null }),

  // Per-resource selectors (Sprint 106, 106.1).
  isResourceLoading: (key: string) => get().loadingByKey[key] === true,
  getResourceError: (key: string) => get().errorByKey[key] ?? null,
});
